module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving10-24707b94f8a8a08ba2484f50f36c9d49.jpg";